module.exports = __webpack_public_path__ + "static/media/favorite_border-24px.1925a45f.svg";